import React, { useContext, useEffect, useState } from "react";
import {
  getAppointments,
  updateAppointmentStatus,
} from "../API/AppointmentsApi";
import AuthContext from "../Context/AuthProvider";
import { convertUTCToTimeZone, convertUTCToTimeZoneDateTimeString } from "../Utility/DateTimeUtility";
import { AppointmentStatus, DateRangeOptions } from "../Utility/Constants";
import { Modal } from "bootstrap";
import { getDisplayValue } from "../Utility/Utility";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Fab,
  Grid2,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  Card,
  CardContent,
  CardActions,
  Divider,
  useMediaQuery,
  useTheme,
  Grid,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import MedicationIcon from "@mui/icons-material/Medication";
import DateRangeDialog from "./ChangeDates";
import dayjs from "dayjs";
import TodayQueue from "./TodayQueue";
import { getVisits } from "../API/VisitsApi";
import { useSnackbar } from "../Utility/UserMessageContext";
import InitialVisitInfo from "./InitialVisitInfo";
import ChangeVisitDialog from "./ChangeVisitDialog";
import { formatAge } from "../Utility/Utility";

function AppointmentListNew1({
  onViewDetails,
  onAddNewAppointment,
  onAddNewPrescription,
  onEditVisit,
}) {
  const {auth} = useContext(AuthContext);
  const [allAppointments, setAllAppointments] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState();
  const [newStatus, setNewStatus] = useState();
  const [showSpinner, setShowSpinner] = useState(false);
  const checkInPatientModalId = "checkIn" + selectedAppointment?.id;
  const [showQueue, setShowQueue] = useState();
  const appointmentStatusList = [
    "Scheduled",
    "CheckedIn",
    "InProgress",
    "Cancelled",
    "Completed",
    "NoShow",
  ];
  const {showSnackbar} = useSnackbar();
  // Theme for responsive design
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
 
  const [keyForRescheduleRendering, setKeyForRescheduleRendering] = useState(0);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);
  const [openVisitInfoDialog, setOpenVisitInfoDialog] = useState(false);
  const [openEditVisitDialog, setOpenEditVisitDialog] = useState(false);
  const handleMenuOpen = (event, row) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRow(row); // Keep track of the selected row
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setCurrentRow(null);
  };

  const [filters, setFilters] = useState({
    from: dayjs(new Date()),
    to: dayjs(new Date()).add(7, "days"),
    selectedDateRangeOption: DateRangeOptions.Next7Days,
    statusList: appointmentStatusList,
  });

  useEffect(() => {
    const fetchData = async () => {
      setShowSpinner(true);
      var result = await getVisits(auth, filters);
      if (result.isSuccess) {
        setAllAppointments(result?.data);
      }
      else
      {
        showSnackbar(result?.data, "error");
      }
      setShowSpinner(false);
    };

    fetchData();
  }, [auth, filters]);

  const [pageSize, setPageSize] = useState(5);

  const showStatusUpdateModal = (newStatus) => {
    const modalElement = document.getElementById(checkInPatientModalId);
    if (modalElement) {
      setNewStatus(newStatus);
      const modal = new Modal(modalElement, {});
      modal.show();
      handleMenuClose();
    }
  };

  const rescheduleAppointment = () => {
    onEditVisit(selectedAppointment);
    // setOpenEditVisitDialog(true);
    // handleMenuClose();
  }

  const resetRescheduleAppointmentForm = () => {
    setKeyForRescheduleRendering((prevKey) => prevKey + 1);
  };

  const onStatusChanged = async () => {
    var result = await updateAppointmentStatus(
      auth,
      selectedAppointment?.id,
      newStatus
    );
    if (result.isSuccess) {
      const modal = Modal.getOrCreateInstance("#" + checkInPatientModalId);
      modal.hide();
      refreshList();
    } else {
      showSnackbar(
        "Error occurred while changing the status of the appointment.", "error"
      );
    }
  };

  const onRowClick = async (e) => {
    setSelectedAppointment(e?.row);
  };

  const refreshList = async () => {
    setShowSpinner(true);
    var result = await getAppointments(auth, filters);

    if (result.isSuccess) {
      setAllAppointments(result?.data);
    }

    setShowSpinner(false);
  };

  const columns = [
    { field: "displayId", headerName: "ID", width: 180 },
    {
      field: "patient",
      type: "text",
      headerName: "Patient",
      width: 180,
      renderCell: (params) =>
        params?.row?.patientPrefix +
        " " +
        params?.row?.patientFirstName +
        " " +
        params?.row?.patientLastName 
       
    },
    {
          field: 'patientGender',
          headerName: 'Gender',
          width: 100,
          renderCell: (params) => params.row.patientGender || '',
        },
        {
          field: 'patientAge',
          headerName: 'Age',
          width: 100,
          renderCell: (params) => formatAge(params.row.patientAgeInYears),
        },
    {
      field: "patientContact",
      type: "text",
      headerName: "Patient Contact",
      width: 130,
      renderCell: (params) =>
        params?.row?.patientMobileNo
    },
    {
      field: "EmailId",
      type: "text",
      headerName: "Email ID",
      width: 200,
      renderCell: (params) => params?.row?.patientEmailId,
    },
    {
      field: "physician",
      headerName: "Physician",
      width: 200,
      renderCell: (params) =>
        params?.row?.physicianPrefix +
        " " +
        params?.row?.physicianFirstName +
        " " +
        params?.row?.physicianLastName,
    },
    {
      field: "service",
      headerName: "Primary Service",
      width: 180,
      renderCell: (params) => params?.row?.primaryServiceName,
    },
    {
      field: "currentVisitType",
      headerName: "Visit Type",
      width: 180,
      renderCell: (params) => getDisplayValue(params?.row?.currentVisitType),
    },
    {
      field: "scheduledStartDateTime",
      headerName: "Visit Time",
      width: 220,
      renderCell: (params) =>
        convertUTCToTimeZoneDateTimeString(params?.row?.scheduledStartDateTime, auth?.selectedFacility?.timeZone),
    },
    
    {
      field: "visitStatus",
      headerName: "Status",
      width: 180,
      renderCell: (params) => getDisplayValue(params?.row?.status),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      headerClassName: 'sticky-column',  // You can add a custom class to style this column
      cellClassName: 'sticky-column', // You can add a custom class to style  
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          {/* View Details Icon */}

          <Tooltip title="View Details" arrow>
            <IconButton
              variant="outlined"
              onClick={() => onViewDetails(params.row)}
            >
              <EventNoteOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          {/* Status Menu Icon */}
          {params.row.status !== AppointmentStatus.Completed && (
            <Tooltip title="Change Appointment" arrow>
              <IconButton
                variant="outlined"
                onClick={(event) => handleMenuOpen(event, params?.row)}
              >
                <CreateOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {params.row.status === AppointmentStatus.InProgress && (
            <Tooltip title="New Prescription" arrow>
              <IconButton
                variant="outlined"
                onClick={() => onAddNewPrescription(params?.row?.id)}
              >
                <MedicationIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];
 
  // Action buttons for card view
  const renderCardActions = (appointment) => {
    return (
      <CardActions sx={{ justifyContent: "flex-end", px: 1, pb: 1 }}>
        <Button
          title="View Details"
          onClick={() => onViewDetails(appointment)}
          variant="outlined"
          size="small"
          startIcon={<EventNoteOutlinedIcon />}
        >
         
        </Button>
       
        {appointment.status !== AppointmentStatus.Completed && (
          <Button
            title="Change Appointment"
            onClick={(event) => {
              setSelectedAppointment(appointment);
              handleMenuOpen(event, appointment);
            }}
            size="small"
            variant="outlined"
            startIcon={<CreateOutlinedIcon />}
            color="secondary"
          >
           
          </Button>
        )}
       
        {appointment.status === AppointmentStatus.InProgress && (
          <Button
            title="New Prescription"
            onClick={() => onAddNewPrescription(appointment?.id)}
            size="small"
            variant="outlined"
            startIcon={<MedicationIcon />}
            color="success"
          >
            Prescription
          </Button>
        )}
      </CardActions>
    );
  };
 
  // Card view for small screens
const renderCardView = () => {
  return (
    <Grid2 sx={{ px: 1 }}>
      {showSpinner ? (
        <Typography variant="body1" align="center" py={3}>Loading...</Typography>
      ) : allAppointments.length === 0 ? (
        <Typography variant="body1" align="center" py={3}>
          There are no visits to display. Change the dates or create a new visit.
        </Typography>
      ) : (
        allAppointments.map((appointment) => (
          <Card
            item
            xs={12}
            key={appointment.id}
            variant="outlined"
            sx={{ mb: 2, borderRadius: 2 }}
            onClick={() => setSelectedAppointment(appointment)}
          >
            <CardContent>
              <Typography  variant="body2" fontWeight="bold">
                {appointment.primaryServiceName}
              </Typography>
              <Typography  variant="body2" fontWeight="bold">
                {`${appointment.patientPrefix || ""} ${appointment.patientFirstName || ""} ${appointment.patientLastName || ""}`}
              </Typography>
             
              <Divider sx={{ my: 1 }} />
             
              <Typography variant="body2" >Gender: {appointment.patientGender || "-"}</Typography>
              <Typography variant="body2">Age: {formatAge(appointment.patientAgeInYears)}</Typography>
              <Typography variant="body2">Contact: {appointment.patientMobileNo || "-"}</Typography>
              <Typography variant="body2">
                Scheduled: {appointment.scheduledStartDateTime ?
                  convertUTCToTimeZone(
                    appointment.scheduledStartDateTime,
                    auth?.selectedFacility?.timeZone
                  ).format("ddd, MMM D, YYYY h:mm A")
                  : "Not scheduled"}
              </Typography>
              <Typography variant="body2">Status: {getDisplayValue(appointment?.visitStatus) || "-"}</Typography>
             
            <CardActions sx={{ justifyContent: "flex-end", }}>
                <Tooltip title="View Details">
                  <IconButton
                    onClick={() => onViewDetails(appointment)}
                    size="small"
                  >
                    <EventNoteOutlinedIcon />
                  </IconButton>
                </Tooltip>
 
                {appointment.status !== AppointmentStatus.Completed && (
                  <Tooltip title="Change Appointment">
                    <IconButton
                      onClick={(event) => {
                        setSelectedAppointment(appointment);
                        handleMenuOpen(event, appointment);
                      }}
                      size="small"
                      color="secondary"
                    >
                      <CreateOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                )}
 
                {appointment.status === AppointmentStatus.InProgress && (
                  <Tooltip title="New Prescription">
                    <IconButton
                      onClick={() => onAddNewPrescription(appointment?.id)}
                      size="small"
                      color="success"
                    >
                      <MedicationIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </CardActions>
            </CardContent>
          </Card>
        ))
      )}
    </Grid2>
  );
};
 
  return (
    <>
      <Grid2 container>
        <Grid2
  container
  size={12}
  alignItems="center"
  justifyContent="space-between"
  spacing={0}
  sx={{ px: 1, py: 1 }}
>
  {/* Left Side: Date Range Display */}
      <Grid2 item sx={{ display: 'flex', alignItems: 'center' , flexWrap: 'wrap',
           width: { xs: '100%', sm: 'auto' },
           mb: { xs: 1, sm: 0 } }}
          >
            <Typography variant="body1">
              Showing appointments from {filters?.from?.format("DD/MM/YYYY")} to {filters?.to?.format("DD/MM/YYYY")}
            </Typography>
            <Tooltip title="Change Dates" arrow>
              <IconButton
                color="secondary"
                size="small"
                onClick={() => setOpenDateRangeDialog(true)}
                sx={{ paddingLeft: "0px", marginLeft: "8px" }}
              >
                <EditCalendarOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Grid2>
 
  
 <Grid2
  container
  xs={12}
  md={6}
  display="flex"
  justifyContent={{ xs: "space-between", md: "flex-end" }}
  alignItems="center"
  gap={1}
  sx={{ pr: 0, mt: { xs: 1, md: 0 } }}
>
  {/* New Visit Button */}
  <Grid2 xs={6} md="auto">
    <Tooltip title="New Visit" arrow>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setOpenVisitInfoDialog(true)}
        size="small"
        sx={{ 
          minWidth: 0,
          width: { xs: 36, md: 'auto' },
          height: 36,
          p: { xs: 0, md: '6px 16px' },
          order: { xs: 1, md: 1 },
          '& .MuiButton-startIcon': {
            margin: 0,
            mr: { xs: 0, md: 1 }
          }
        }}
        startIcon={<AddRoundedIcon fontSize="small" />}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' } }}>
          New Visit
        </Box>
      </Button>
    </Tooltip>
  </Grid2>

  {/* Today's Queue Button */}
  {/* <Grid2 
    xs={6} 
    md="auto" 
    display="flex" 
    justifyContent={{ xs: "flex-end", md: "unset" }}
  >
    <Tooltip title="Today's Queue" arrow>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setShowQueue(!showQueue)}
        size="small"
        sx={{ 
          minWidth: 0,
          width: { xs: 36, md: 'auto' },
          height: 36,
          p: { xs: 0, md: '6px 16px' },
          order: { xs: 2, md: 2 },
          '& .MuiButton-startIcon': {
            margin: 0,
            mr: { xs: 0, md: 1 }
          }
        }}
        startIcon={<FormatListNumberedOutlinedIcon fontSize="small" />}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' } }}>
          
        </Box>
      </Button>
    </Tooltip>
  </Grid2> */}
  
<Grid2 
    xs={6} 
    md="auto" 
    display="flex" 
    justifyContent={{ xs: "flex-end", md: "unset" }}
  >
    <Tooltip title="Today's Queue" arrow>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setShowQueue(!showQueue)}
        size="small"
        sx={{ 
          minWidth: 0,
          width: 36,
          height: 36,
          p: 0,
          order: { xs: 2, md: 2 },
          '& .MuiButton-startIcon': {
            margin: 0
          }
        }}
      >
        <FormatListNumberedOutlinedIcon fontSize="small" />
      </Button>
    </Tooltip>
  </Grid2>
</Grid2>

</Grid2>
  {(!isSmallScreen || !showQueue) && (
        <Box
          sx={{
          width: isSmallScreen ? "100%" : showQueue ? "80%" : "100%",
          transition: "width 0.3s ease",
          paddingX: "5px",
          height: isSmallScreen ? 'auto' : 600,
          maxHeight: "calc(100vh - 180px)",
          overflowY: "auto"
        }}
        >
          {isSmallScreen ? (
            renderCardView()
          ) : (
            <DataGrid
              localeText={{noRowsLabel:"There are no visits to display. Change the dates or create a new visit."}}
              loading={showSpinner}
              slotProps={{
                loadingOverlay:{
                  variant: 'skeleton',
                  noRowsVariant: 'skeleton',
                }
              }}
              initialState={{
                density: "compact",
                pagination: {
                  paginationModel: { pageSize: 5 }, // Default page size
                },
              }}
              sx={{width:'100%',
                "& .sticky-column": {
                  position: "sticky",
                  right: 0, // Keep it on the right side
                  backgroundColor: "white", // To make sure it has a solid background
                  zIndex: 100, // Ensure it stays on top of other columns
                },
              }}
              rows={allAppointments} //filteredAppointments
              columns={columns}
              pageSizeOptions={[5, 10, 15]}
              rowsPerPageOptions={[5, 10, 15]}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              onRowClick={onRowClick}
            />
          )}
          
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={handleMenuClose}
          >
            {currentRow && (
              <>
                {(currentRow.visitStatus === AppointmentStatus.Cancelled ||
                  currentRow.visitStatus === AppointmentStatus.CheckedIn ||
                  currentRow.visitStatus === AppointmentStatus.Scheduled) && (
                  <MenuItem onClick={rescheduleAppointment}>
                    Reschedule
                  </MenuItem>
                )}
                {currentRow.visitStatus === AppointmentStatus.Scheduled && 
                convertUTCToTimeZone(currentRow.visitDateTime, auth?.selectedFacility?.timeZone).format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD") && (
                  <MenuItem
                    onClick={() =>
                      showStatusUpdateModal(AppointmentStatus.CheckedIn)
                    }
                  >
                    Check In
                  </MenuItem>
                )}
                {(currentRow.visitStatus === AppointmentStatus.Scheduled ||
                  currentRow.visitStatus === AppointmentStatus.CheckedIn) && (
                  <MenuItem
                    onClick={() =>
                      showStatusUpdateModal(AppointmentStatus.Cancelled)
                    }
                  >
                    Cancel
                  </MenuItem>
                )}
                {currentRow.visitStatus === AppointmentStatus.InProgress && (
                  <MenuItem
                    onClick={() =>
                      showStatusUpdateModal(AppointmentStatus.Completed)
                    }
                  >
                    Complete
                  </MenuItem>
                )}
                {currentRow.visitStatus === AppointmentStatus.Scheduled && 
                convertUTCToTimeZone(currentRow.visitDateTime, auth?.selectedFacility?.timeZone).isBefore(dayjs()) &&(
                  <MenuItem
                    onClick={() =>
                      showStatusUpdateModal(AppointmentStatus.NoShow)
                    }
                  >
                    No Show
                  </MenuItem>
                )}
              </>
            )}
          </Menu>
          {/* </Box> */}
        </Box>
        )}
        {!isSmallScreen && (
          <Box
            sx={{
              display: "flex",
              width: showQueue ? "20%" : "0", // Control the width based on open state
              transition: "width 1s ease", // Smooth transition for the width
              justifyContent: "flex-end", // Position collapsible on the right
              overflow: "hidden", // Hide content that goes outside the box
            }}
          >
            <Box
              sx={{
                height: 500, // Fixed height for the collapsible
                width: showQueue ? "100%" : "0", // Control the width based on open state
                transition: "width 1s ease", // Smooth transition for the width
              }}
            >
              <TodayQueue/>
            </Box>
          </Box>
        )}
        <Grid2  sx={{maxHeight: "calc(100vh - 150px)", overflowY: "auto"}}>
          {/* For small screens, show queue as a full width section if enabled */}
          {isSmallScreen && showQueue && (
            <Box
        sx={{
          width: isSmallScreen ? "100%" : "20%",
          height: isSmallScreen ? 'auto' : 500,
          paddingX: "5px",
          ml: isSmallScreen ? 0 : "5px",
          transition: "all 0.3s ease"
        }}
      >
        <TodayQueue/>
      </Box>
        )}
        </Grid2>
      </Grid2>
      <div class="container-fluid">

        <div class="row justify-content-center align-items-center mt-4">
          <div
            class="modal"
            tabindex="-1"
            id={checkInPatientModalId}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Change Status</h5>
                </div>
                <div class="modal-body">
                  <p>
                    You are changing the status of the appointment from{" "}
                    {selectedAppointment?.status} to {newStatus} for the patient
                    - {selectedAppointment?.patient?.firstName}. Are you sure?
                  </p>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    onClick={onStatusChanged}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <ChangeVisitDialog
              key={keyForRescheduleRendering}
              refreshAppointments={refreshList}
              reset={resetRescheduleAppointmentForm}
              visit={selectedAppointment}
              openState={openEditVisitDialog}
              setOpenState={setOpenEditVisitDialog}
            ></ChangeVisitDialog>
          </div>
          <DateRangeDialog
            key="visits"
            title="Show Visits For"
            filters={filters}
            setFilters={setFilters}
            openState={openDateRangeDialog}
            setOpenState={setOpenDateRangeDialog}
            // onApply={handleApplyDateRange}
          ></DateRangeDialog>
          <InitialVisitInfo
            key="visits1"
            openState={openVisitInfoDialog}
            setOpenState={setOpenVisitInfoDialog}
            onApply={onAddNewAppointment}
          ></InitialVisitInfo>
        </div>
      </div>
    </>
  );
}

export default AppointmentListNew1;
